<template>
        <div class="r-column fr bgw mht-400">
            <Crumb :typeId="typeId"></Crumb>
            <div v-if="!count" class="tcenter tc9 fs18 no-cont">
                <div class="iconfont icon-kongneirong"></div>
                抱歉，没有相关内容
            </div>
            <div class="dis-list fs24 ofhidden">
                <router-link v-for="(item, key) in newsList" :key="item.id"
                    :to="`${$params.baseDir}edu/detail/${item.id}?typeId=${item.category_id}`"
                    class="dis1 dis fl br8 dflex jc-center ai-center mb15 twhite"
                >
                    {{item.title}}
                </router-link>
            </div>
			 <!--class="`dis${key % 9}`" -->
            <Page v-if="count" 
                    :pageNum="page + 1" 
                    :pageSize="pageSize" 
                    :count="count" 
                    :showCount="false" 
                    @chagePage="chagePage" 
            />
        </div>
        

</template>
<script>
import Crumb from '@/components/common/Crumb'
import NoticeList from '@/components/notice/NoticeList'
import Page from '@/components/common/MyPagination'
import { throws } from 'assert'
export default {
    data() {
        return {
            newsList: [],
            typeId: 0,
            typeNm: '',
            type: '',
            page: 0,
            pageSize: 30,
            count: 0,
            isFirst: true
        }
    },
    components: {
        Crumb,
        NoticeList,
        Page
    },
    created() {
        this.initData()
    },
    watch: {
        $route: {
            //immediate: true,
            deep: true,
            handler: function (nV, oV) {
                if (nV.params.id != oV.params.id) {
                    this.isLoad = false
                    this.count = 0
                    this.page = 0
                    this.initData()
                }
            }
        }
    },
    methods: {
        initData() {
            this.typeId = this.$route.params.id
            this.getNewsList()
        },
        getNewsList() {
            const query = {
                category_id: this.typeId,
                page: this.page + 1,
                perPage: this.pageSize
            }
            this.$request.get('article/list', query, res => {
                if (res.data.code == 200) {
                    const data = res.data.data
                    this.newsList = data.data
                    this.count = parseInt(data.total)
                    this.isLoad = false
                    console.log(this.newsList)
                }
            }, err => {
                console.log(err)
                this.isLoad = false
            })
        },
        chagePage(page) {
            this.page = page - 1
            this.getNewsList()
        }

    }
}
</script>
<style scope>
.no-cont {
    margin-top: 80px;
}
</style>
